export const DEFAULT_ADJUSTMENT_KEY = "competent";

export const ADJUSTMENT_OPTIONS = [
  {
    key: "novice",
    label: "High Touch",
    laborTargetPercent: 15,
    description:
      "Adds labor to support customer service, execution quality, or locations that need extra coverage.",
    chipClasses: "border border-rose-200 bg-rose-50 text-rose-700",
    selectedClasses: "border-rose-300 bg-rose-50",
  },
  {
    key: "extra_support",
    label: "Extra Support",
    laborTargetPercent: 10,
    description:
      "Adds more coverage for stores that need stronger support, without moving all the way to high-touch staffing.",
    chipClasses: "border border-orange-200 bg-orange-50 text-orange-700",
    selectedClasses: "border-orange-300 bg-orange-50",
  },
  {
    key: "beginner",
    label: "Supportive",
    laborTargetPercent: 5,
    description:
      "Adds a modest labor buffer for stores that need a little more support than the company baseline.",
    chipClasses: "border border-amber-200 bg-amber-50 text-amber-700",
    selectedClasses: "border-amber-300 bg-amber-50",
  },
  {
    key: "competent",
    label: "Standard",
    laborTargetPercent: 0,
    description:
      "Matches the company baseline labor target and is the best neutral starting point.",
    chipClasses: "border border-violet-200 bg-violet-50 text-violet-700",
    selectedClasses: "border-violet-300 bg-violet-50",
  },
  {
    key: "intermediate",
    label: "Efficient",
    laborTargetPercent: -5,
    description:
      "Runs slightly leaner than baseline while still preserving a fairly standard operating model.",
    chipClasses: "border border-sky-200 bg-sky-50 text-sky-700",
    selectedClasses: "border-sky-300 bg-sky-50",
  },
  {
    key: "advanced",
    label: "Lean",
    laborTargetPercent: -10,
    description:
      "Reduces labor more aggressively for stores that consistently operate with strong execution.",
    chipClasses: "border border-emerald-200 bg-emerald-50 text-emerald-700",
    selectedClasses: "border-emerald-300 bg-emerald-50",
  },
  {
    key: "expert",
    label: "Very Lean",
    laborTargetPercent: -15,
    description:
      "Applies the leanest labor target for locations that can sustain a highly efficient service model.",
    chipClasses: "border border-teal-200 bg-teal-50 text-teal-700",
    selectedClasses: "border-teal-300 bg-teal-50",
  },
];

export const ADJUSTMENT_OPTION_LOOKUP = ADJUSTMENT_OPTIONS.reduce(
  (acc, option) => {
    acc[option.key] = option;
    return acc;
  },
  {}
);

export const ADJUSTMENT_MARKS = ADJUSTMENT_OPTIONS.map((option, index) => ({
  value: index,
  label: option.label,
}));

export const formatLaborTargetDelta = (value) => {
  if (value === 0) {
    return "0% labor";
  }

  return `${value > 0 ? "+" : ""}${value}% labor`;
};

export const getAdjustmentIndex = (key) => {
  const index = ADJUSTMENT_OPTIONS.findIndex((option) => option.key === key);
  return index === -1
    ? ADJUSTMENT_OPTIONS.findIndex((option) => option.key === DEFAULT_ADJUSTMENT_KEY)
    : index;
};

export const getAdjustmentKeyForIndex = (value) => {
  return ADJUSTMENT_OPTIONS[value]?.key || DEFAULT_ADJUSTMENT_KEY;
};
